export default __webpack_public_path__ + "static/media/headset15.a1fa0d56.jfif";